import {
  deleteAllSearchAlerts
} from "./chunk-ZMHFAQNV.js";
import {
  getConfigWithMetadata,
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/deleteAllSearchAlerts/deleteAllSearchAlerts.ts
async function deleteAllSearchAlerts2(apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "deleteAllSearchAlerts");
    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
      );
    }
    await deleteAllSearchAlerts(_apiConfig);
    return { status: "success", data: void 0 };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  deleteAllSearchAlerts2 as deleteAllSearchAlerts
};
